export default "__VITE_ASSET__VIhR_PDL__"